// Module
var code = "<script>let $ctrl</script> <div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <molecule-wizard-supervisor wizard-objects=\"$ctrl.serviceObjects\"></molecule-wizard-supervisor> ";
// Exports
module.exports = code;